import React, { useContext, useState } from 'react'
import { Body, Container, Header, Title } from './styled'
import { DefaultContent } from '../../components/common/DefaultContent'
import { CheckCircle, Notepad, UsersFour } from '@phosphor-icons/react'
import { ActionCard } from '../../components/ActionCard'
import { SideTab } from '../../components/SideTab'

import { Modal } from '../../components/Modal'
import { Button } from '../../components/common/Button'
import { BaseRegisterTable } from './components/BaseRegistarTable'
import { NewBase } from './components/NewBase'
import { EditUser } from './components/EditUser'
import { BaseContext } from '../../context/context_baseRegister'
import api from '../../services/api'

import { Helmet } from 'react-helmet'

interface BaseDataProps {
  id?: string
  base: string
  outpost: string
  Address: [
    {
      address: string
      zipcode: string
      burgh: string
      city: string
      state: string
      latitude: number
      longitude: number
    },
  ]
}

export const BaseRegister = () => {
  const [newUserState, setNewUserState] = useState<boolean>(false)
  const [newUserRegistered, setNewUserRegistered] = useState<boolean>(false)

  const [editUser, setEditUser] = useState<boolean>(false)
  const [confirmEditUser, setConfirmEditUser] = useState<boolean>(false)

  const { baseList } = useContext(BaseContext)

  const [data, setData] = useState<BaseDataProps>()

  const handleEditModal = async (id: string) => {
    try {
      const response = await api.post('/v1/dashboard/base/find', { id })
      setData(response.data)
      setEditUser((prev) => !prev)
    } catch (err) {
      console.log(err)
    }
  }

  function handlerState(state) {
    state((prev) => !prev)
  }

  function closeModals() {
    setNewUserState(false)
    // setConfirmNewUser(false)
    setNewUserRegistered(false)
  }

  return (
    <>
      <Helmet>
        <title>Previx - Cadastro de base</title>
        <meta
          name="Previx - Cadastro de base"
          content="Página de cadastro de base previx"
        />
      </Helmet>
      <DefaultContent
        icon={<UsersFour size={26} color="#003E5F" weight="fill" />}
        title="Previx - Funcionários - Cadastro de base"
      >
        <Container>
          <Header>
            <ActionCard.Root>
              <ActionCard.Content
                onclick={() => handlerState(setNewUserState)}
                background="#52427B"
                border="#BBA7E3"
                color="#fff"
              >
                <ActionCard.Icon
                  transform={20}
                  icon={<Notepad size={60} weight="fill" color="#BBA7E3" />}
                />

                <ActionCard.Information value="Cadastrar nova base" />
              </ActionCard.Content>
            </ActionCard.Root>
          </Header>
          <Body>
            <Title>Lista de bases cadastrados na plataforma</Title>
            <BaseRegisterTable editOnClick={handleEditModal} data={baseList} />
          </Body>
        </Container>
      </DefaultContent>
      {/* Sidetab New user */}
      <SideTab
        open={newUserState}
        title="Cadastro de base"
        toggleFunction={() => handlerState(setNewUserState)}
        width="50%"
      >
        <NewBase />
      </SideTab>

      {/* Sidetab  New user */}

      {/* Modals New user */}

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={newUserRegistered}
        setIsOpenController={closeModals}
      >
        <Modal.Header onclick={closeModals} />
        <Modal.Icon icon={<CheckCircle size={60} color="#00517D" />} />
        <Modal.Content
          value="Dados atualizados!"
          subvalue="Ao acessar novamente as informações de bases, você verá as novas informações cadastradas."
        />
        <Modal.Footer>
          <Button.Root backgroundColor="#00517D">
            <Button.Content title="Voltar para página" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
      {/* Modals  New base */}

      {/* Sidetab  Edit base */}
      <SideTab
        open={editUser}
        title="Editar base"
        toggleFunction={() => handlerState(setEditUser)}
        width="50%"
      >
        <EditUser
          onclick={() => handlerState(setConfirmEditUser)}
          data={data}
        />
      </SideTab>
      {/* Sidetab  Edit base */}

      {/* Modals Edit base */}

      {/* Modals Edit User */}
    </>
  )
}
